import { Component, Input } from '@angular/core';
import { DragContext } from '@mydocma/component-library/src/lib/drag-drop';

@Component({
  selector: 'mydocma-dropable',
  templateUrl: './dropable.component.html',
  styleUrls: ['./dropable.component.scss'],
})
export class DropableComponent {
  @Input() dragContext: DragContext;
  @Input() pinNumber: string = null;
}
